import { createSelector } from 'reselect'

/**
 * Select the chat state slice
 * @param {object} state - Redux state
 * @returns {object} Chat state
 */
export const selectChat = (state) => state.chat

/**
 * Select chat messages
 * @param {object} state - Redux state
 * @returns {Array} Chat messages
 */
export const selectChatMessages = createSelector(
  selectChat,
  (chat) => chat.messages
)

/**
 * Select chat messages in reverse chronological order
 * @param {object} state - Redux state
 * @returns {Array} Reversed chat messages
 */
export const selectMessagesReversed = createSelector(
  selectChatMessages,
  (messages) => messages?.slice().reverse() || []
)

/**
 * Select chat response messages
 * @param {object} state - Redux state
 * @returns {Array} Response messages
 */
export const selectResponseMessages = createSelector(
  selectChat,
  (chat) => chat.responseMessages
)

/**
 * Select the unread message index
 * @param {object} state - Redux state
 * @returns {number} Unread message index
 */
export const selectUnreadMessageIndex = createSelector(
  selectChat,
  (chat) => chat.unreadMessageIndex
)

/**
 * Select whether the scroll indicator is visible
 * @param {object} state - Redux state
 * @returns {boolean} Scroll indicator visibility
 */
export const selectShowScrollIndicator = createSelector(
  selectChat,
  (chat) => chat.showScrollIndicator
)
